import { OperatorWithStatus } from "gql/generated";
import { getOperatorStatus } from "./getOperatorStatus";
import * as i18n from "i18next";
import { StatusIndicatorVariants } from "shared/components/molecules/StatusIndicator/statusIndicator.recipe";

export const getStatusIndicatorByPublicationStatus = (
  operator: OperatorWithStatus,
  organizationId: string,
) => {
  const status = getOperatorStatus(operator, organizationId);
  let label: string = "";
  const variant: StatusIndicatorVariants = {
    display: "row",
    visual: "error",
  };
  let numFilled = 0;

  if (status.isNotInvited) {
    label = i18n.t("directory:HEADER.ACTIONS.NOT_INVITED");
    variant.visual = "warning";
  } else if (status.isInvited) {
    label = i18n.t("directory:HEADER.ACTIONS.INVITED");
    variant.visual = "warning";
    numFilled = 1;
  } else if (status.isInvitedAccepted) {
    label = i18n.t("directory:HEADER.ACTIONS.INVITED_ACCEPTED");
    variant.visual = "warning";
    numFilled = 2;
  } else if (status.isNeedsApproval) {
    label = i18n.t("directory:HEADER.ACTIONS.NEEDS_APPROVAL");
    variant.visual = "warning";
    numFilled = 3;
  } else if (status.isApproved) {
    label = i18n.t("directory:HEADER.ACTIONS.APPROVED");
    variant.visual = "success";
    numFilled = 4;
  } else if (status.isUnpublished) {
    label = i18n.t("directory:HEADER.ACTIONS.UNPUBLISHED");
  }

  return { label, variant, numFilled };
};
